var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button"},[(_vm.direction === 'right')?_c('span',[_c('i',{staticClass:"fas fa-arrow-right"})]):_c('span',[_c('i',{staticClass:"fas fa-arrow-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }